let screenW = $(window).width()
let screenH = $(window).height()

export function setScreenSize()
{
  screenW = $(window).width()
  screenH = $(window).height()
}
function breakpoint(breakpoint)
{
  let breakpoints = {
    'xs': 0,
    'sm': 400,
    'md': 743,
    'lg': 992,
    'xl': 1200,
    'xxl': 1600,
    'hd': 1930,
    'screenW': screenW,
    'screenH': screenH,
  }
  return breakpoints[breakpoint]
}

function breakpointUp(value)
{
  return breakpoint('screenW') >= breakpoint(value)
}

function breakpointDown(value)
{
  return breakpoint('screenW') < breakpoint(value)
}

function screenSizeCoefficient()
{
  let coefficient = 1
  if (breakpoint('screenW') > breakpoint('hd')) {
    coefficient = breakpoint('screenW') /  breakpoint('hd')
  }

  return coefficient
}

export { breakpoint, screenSizeCoefficient, breakpointUp, breakpointDown }
